// import { gsap } from 'gsap';

document.querySelectorAll('.js-video-popup').forEach((trigger) => {
  trigger.addEventListener('click', (e) => {
    e.preventDefault();

    const videoUrl = trigger.dataset.video;
    const overlay = document.createElement('div');
    overlay.className = 'video-popup-overlay';
    overlay.innerHTML = `
      <div class="video-popup-inner">
        <button class="video-popup-close" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M504.6 148.5C515.9 134.9 514.1 114.7 500.5 103.4C486.9 92.1 466.7 93.9 455.4 107.5L320 270L184.6 107.5C173.3 93.9 153.1 92.1 139.5 103.4C125.9 114.7 124.1 134.9 135.4 148.5L278.3 320L135.4 491.5C124.1 505.1 125.9 525.3 139.5 536.6C153.1 547.9 173.3 546.1 184.6 532.5L320 370L455.4 532.5C466.7 546.1 486.9 547.9 500.5 536.6C514.1 525.3 515.9 505.1 504.6 491.5L361.7 320L504.6 148.5z"/></svg></button>
        <video src="${videoUrl}" controls autoplay playsinline></video>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    const close = () => {
      overlay.remove();
      document.body.style.overflow = '';
    };

    overlay.querySelector('.video-popup-close').addEventListener('click', close);
    overlay.addEventListener('click', (ev) => {
      if (ev.target === overlay) close();
    });
    document.addEventListener('keydown', function onKey(ev) {
      if (ev.key === 'Escape') {
        close();
        document.removeEventListener('keydown', onKey);
      }
    });
  });
});
